import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top scroll listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Smooth scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-neutral-900 dark:bg-white 
            text-white dark:text-neutral-900 p-3 rounded-full shadow-lg
            hover:bg-neutral-700 dark:hover:bg-neutral-200
            transform hover:-translate-y-1 transition-all duration-200
            flex items-center gap-2 group z-50"
          aria-label="Back to top"
        >
          <span className="text-sm font-medium">Back to Top</span>
          <ChevronUp className="w-4 h-4 group-hover:-translate-y-px transition-transform duration-200" />
        </button>
      )}
    </>
  );
};

export default BackToTop;